<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbIcons',
  components: {},
}
</script>
